// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2eeZF","loaderOuter":"PageOverlayLoader_loaderOuter__3aSAM"};